/**
 * Function which returns the pageType of the current page as a string
 * @function getPageType
 * @param path {String} - The path / pathname - '/services/some-page/'
 * @returns {String} The pageType - 'services', 'industries', etc
 */
const getPageType = (path) => {
  let firstSlashIndex = path.indexOf('/');

  if (path.includes('de-de') || path.includes('en-au') || path.includes('en-gb') || path.includes('en-us') || path.includes('en-in')) {
    firstSlashIndex = path.indexOf('/', firstSlashIndex + 1);
  }

  return path.substring(firstSlashIndex + 1, path.indexOf("/", firstSlashIndex + 1));
};

export default getPageType;
